<div class="layout-sidebar no-print"
  [ngClass]="{'layout-sidebar-active': app.sidebarActive, 'layout-sidebar-dark': app.darkMenu}"

    (click)="app.onSidebarClick($event)" (mouseover)="app.sidebarActive=true" (mouseleave)="app.sidebarActive=false">
    <div class="sidebar-logo" [ngStyle]="(app.layoutMode === 'overlay' && !app.sidebarActive) ? {'background-color': '#FFF', 'padding-top': '2px'} : {}">
      <a href="#">
        <img
          alt="logo"
          class="menu-side-logo"
          [ngStyle]="(app.layoutMode === 'overlay' && !app.sidebarActive) ? ( isGEEO ? {'float':'right','margin-right':'16px'} : {'float':'right','margin-right':'6px'} )  : {}"
          src='{{ (app.layoutMode === "overlay" && !app.sidebarActive) ? arquivoLogoAbreviadaColorida : arquivoLogoPequena }}' />
      </a>
      <a href="#" class="sidebar-anchor" title="Toggle Menu" (click)="app.onToggleMenuClick($event)"></a>
    </div>

    <p-scrollPanel #scrollPanel [style]="{height: '100%'}">
      <ul app-submenu [item]="model" root="true" class="layout-menu" visible="true" [reset]="reset"></ul>
    </p-scrollPanel>
</div>
